//import useGlobalStore from "@/stores/global.store";
import { useQuery } from '@tanstack/react-query';
import { Group } from '@/types/api/group';
import api from '@/api';

type GroupQueryKey = ['groups', string];

export function useCurrentGroupQuery() {
  return useQuery<Group, Error, Group, GroupQueryKey>({
    queryKey: ['groups', 'current'],
    queryFn: () => api.group.current(),
  });
}
